<template>
  <LoginGuard>
    <div class="container">
      <o-section-dashboard-menu :items="items" />
    </div>
  </LoginGuard>
</template>

<script>
import LoginGuard from "../vue-ocom/auth/components/LoginGuard";
import OSectionDashboardMenu from "@/vue-ocom/components/layout/app/OSectionDashboardMenu";
import MENU_ITEMS from "./menu_items";

export default {
  components: {
    LoginGuard,
    OSectionDashboardMenu,
  },
  data: () => ({
    items: MENU_ITEMS,
  }),
};
</script>
